import { render, staticRenderFns } from "./landing-page-plans.vue?vue&type=template&id=8eb0f0fe&scoped=true&lang=pug"
import script from "./landing-page-plans.js?vue&type=script&lang=js&external"
export * from "./landing-page-plans.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-plans.vue?vue&type=style&index=0&id=8eb0f0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb0f0fe",
  null
  
)

export default component.exports